import type { HTMLAttributes, FC } from 'react';
import defaultAvatar from '../assets/person-fill.svg';
import './Avatar.scss';

interface AvatarComponentProps extends HTMLAttributes<HTMLDivElement> {
  src?: string | null;
}


const Avatar: FC<AvatarComponentProps> = ({ src, className, ...rest }) => {
  const avatarStyle = {
    backgroundImage: `url("${src || defaultAvatar}")`,
  };

  return (<div className={`avatar-circle ${className || ''}`} {...rest}><div className="avatar-pic" style={avatarStyle} /></div>);
};

export default Avatar;